const moment = require('moment');
const State = require('../helpers.js').State;

module.exports = State({
    showPromoCar: (moment().diff(moment("02.12.2024", 'DD.MM.YYYY')) > 0 && moment().diff(moment("01.02.2025", 'DD.MM.YYYY')) < 0), // [~] the 'after' date written here is the first day the banner is not shown anymore. in genere +1 fata de ce ne da roxana'n task...
    validity: 12,
    installments: 1,
    hasDD: false,

    price: 0,
    DDPrice: 0,
    FIPrice: 0,
    bonusMalus: '',
    id: '',

    quotations: State({
        '6': null,
        '12': null,
        'custom': null
    })
});